<template>
    <v-container>
        <v-row>
            <v-col cols="6">
                <h3>
                    Seleziona un cliente per visualizzare i dati del registro di sintesi FSC
                </h3>
            </v-col>
            <v-col cols="6">

                <v-text-field v-model="search" append-icon="search" label="Cerca" single-line clearable
                    class="mt-0 pt-0" />
            </v-col>
        </v-row>
        <v-divider />
        <v-data-table :items="datiClienti" :items-per-page="-1" hide-default-footer :headers="headersDati"
            :search="search" mobile-breakpoint="0">
            <template v-slot:item="{ item }">
                <tr v-on:click.prevent="selectRow(item)" style="cursor: pointer;">
                    <td>{{ item.companyCode }}</td>
                    <td>{{ item.ragioneSociale }}</td>
                </tr>
            </template>
        </v-data-table>
    </v-container>
</template>

<script>
import { get_listaClienti } from '@/api/api.dati.js'

import mixinUtente from "@/utils/dati/mixinUtente";

export default {
    name: 'ElencoClienti',
    mixins: [mixinUtente],

    data() {
        return {
            datiClienti: [],
            headersDati: [
                { text: "Codice cliente", value: "companyCode", sortable: true },
                { text: "Ragione Sociale", value: "ragioneSociale", sortable: true },],

            search: '',
        };
    },

    methods: {
        async caricaDati() {
            let par = {
                Cliente: true,
                Gruppo: "Tutti",
                Certificazione: "Tutti",
                DataCoc: "",
                DataFPC: "",
                abilitaRegistro: true,
                abilitaRegistroPEFC: false,
            }
            if (this.role === 'utente') return;
            let res = await get_listaClienti(par);
            this.datiClienti = res.data;
        },

        selectRow(row) {
            if (!row.companyCode) return;
            this.$router.push({ path: "/registro/" + row.companyCode + "?cliente=" + row.ragioneSociale });
        },
    },

    async mounted() {
        // Al primo caricamento diretto della pagina il ruolo puo' non essere ancora in store
        // (richiesta asincrona avviata da Main.vue): va atteso prima di decidere il redirect.
        if (!this.role) {
            await this.$store.dispatch("user/userInfo");
        }

        // admin e auditor vedono l'elenco (per l'auditor già filtrato lato server alle sole aziende assegnate)
        if (this.role === 'utente') {
            this.$router.push({ path: "/registro/" + this.compCode });
            return;
        }

        this.caricaDati();
    },

    computed: {
        role() {
            return this.$store.getters['user/getRole'];
        },

        compCode() {
            return this.$store.getters["user/getCompanyCode"];
        },
    }
};
</script>